<template>
  <v-layout row wrap ma-0>
    <v-flex xs12>
      <!-- <template v-for="(key, index) in Object.keys(options)">
        <highcharts
          :key="`chart-${index}`"
          v-if="getOptionType(key) !== 'number'"
          :options="getChartOptions(key, options[key])"
        ></highcharts>
      </template>-->
      <highcharts key="chart-age" :options="getChartage()"></highcharts>
      <highcharts key="chart-wound" :options="getChartwound()"></highcharts>
      <highcharts key="chart-woundamount" :options="getChartwoundamount()"></highcharts>
      <highcharts key="chart-crash" :options="getChartcrash()"></highcharts>
    </v-flex>
  </v-layout>
</template>

<script>
import cloneDeep from 'clone-deep';

export default {
  name: 'ResultChart',
  components: {},
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    },
    accidentCount: {
      type: Number,
      default() {
        return 0;
      }
    },
    dataSource: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data: () => ({
    chartOptions: {
      chart: {
        type: 'column'
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      xAxis: {
        type: 'category',
        labels: {
          style: {
            fontSize: '12px',
            fontFamily: 'Sarabun'
          }
        }
      },
      yAxis: {
        title: {
          text: 'จำนวนอุบัติเหตุ',
          style: {
            fontSize: '14px',
            fontFamily: 'Sarabun',
            fontWeight: '400',
            color: '#333333'
          }
        },
        labels: {
          style: {
            fontSize: '14px',
            fontFamily: 'Sarabun'
          }
        }
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            format: '{point.y:,.0f} ครั้ง'
          }
        }
      },
      credits: {
        enabled: false
      },
      colors: ['#BA4438'],
      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat:
          '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> ครั้ง<br/>'
      },
      series: [
        {
          name: '',
          colorByPoint: true,
          dataLabels: {
            style: {
              fontSize: '14px',
              fontFamily: 'Sarabun',
              fontWeight: '400',
              color: '#333333'
            }
          },
          data: []
        }
      ]
    }
  }),
  mounted() {},
  methods: {
    getChartage() {
      const chartage = cloneDeep(this.chartOptions);
      chartage.title.text = 'อายุ';
      chartage.yAxis.title.text = 'จำนวนคน';
      chartage.xAxis.categories = [];
      chartage.legend.enabled = true;
      chartage.plotOptions = {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: true,
            format: '{point.y:,.0f} คน'
          }
        }
      };
      chartage.tooltip = {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}">จำนวน</span>: <b>{point.y}</b> คน<br/>'
      };
      chartage.series = [];
      if (this.options.hasOwnProperty('age')) {
        let casualtyCount = this.getCasualtyCount();
        const agecount = this.options.age.length;
        const male = [];
        const female = [];
        const unknown = [];
        for (let index = 0; index < agecount; index++) {
          const element = this.options.age[index];
          chartage.xAxis.categories.push(`${element.min} - ${element.max}`);
          male.push(element.sex['1']);
          female.push(element.sex['2']);
          unknown.push(0);
          casualtyCount -= element.sex['1'] + element.sex['2'];
        }
        if (casualtyCount > 0) {
          chartage.xAxis.categories.push('ไม่ระบุ');
          male.push(0);
          female.push(0);
          unknown.push(casualtyCount);
        }
        const gender = [
          {
            name: 'ชาย',
            color: '#3494D8',
            data: male
          },
          {
            name: 'หญิง',
            data: female
          },
          {
            name: 'ไม่ระบุ',
            color: '#AAAAAA',
            data: unknown
          }
        ];
        chartage.series = gender;
        // console.warn(chartage);
      }
      return chartage;
    },
    getChartwound() {
      const chartwound = cloneDeep(this.chartOptions);
      chartwound.title.text = 'ระดับความรุนแรง (ครั้ง)';
      const level = [
        'มีผู้บาดเจ็บสาหัส',
        'มีผู้บาดเจ็บเล็กน้อย',
        'มีผู้เสียชีวิต ณ จุดเกิดเหตุ',
        'มีผู้เสียชีวิต ณ โรงพยาบาล',
        'ไม่ได้รับผลกระทบ'
      ];
      if (this.options.hasOwnProperty('wound')) {
        let { accidentCount } = this;
        let index = 1;
        for (; index <= level.length; index++) {
          chartwound.series[0].data.push({
            name: level[index - 1],
            x: index - 1,
            y: this.options.wound[index]
          });
          accidentCount -= this.options.wound[index];
        }
        if (accidentCount > 0) {
          chartwound.series[0].data.push({
            name: 'ไม่ระบุ',
            x: index - 1,
            y: accidentCount
          });
        }
      }
      return chartwound;
    },
    getChartwoundamount() {
      const chartwound = cloneDeep(this.chartOptions);
      chartwound.title.text = 'ความเสียหายต่อตัวบุคคล (คน)';
      chartwound.yAxis.title.text = 'จำนวนคน';
      const level = [
        'ผู้บาดเจ็บสาหัส',
        'ผู้บาดเจ็บเล็กน้อย',
        'ผู้เสียชีวิต ณ จุดเกิดเหตุ',
        'ผู้เสียชีวิต ณ โรงพยาบาล'
      ];
      chartwound.plotOptions = {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            format: '{point.y:,.0f} คน'
          }
        }
      };
      chartwound.tooltip = {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat:
          '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> คน<br/>'
      };
      if (this.options.hasOwnProperty('wound_amount')) {
        for (let index = 1; index <= level.length; index++) {
          chartwound.series[0].data.push({
            name: level[index - 1],
            x: index - 1,
            y: this.options.wound_amount[index]
          });
        }
      }
      return chartwound;
    },
    getChartcrash() {
      const chartcrash = cloneDeep(this.chartOptions);
      chartcrash.title.text = 'รูปแบบการชน';
      const level = [
        'ชนคนเดินเท้า',
        'ชนเป็นมุมบริเวณทางแยก',
        'ชนในทิศทางตรงกันข้าม (ไม่ใช่การแซง)',
        'ชนท้ายและชนด้านข้าง (วิ่งมาในทิศทางเดียวกัน)',
        'เลี้ยว/ถอยชน',
        'ชนขณะแซง',
        'ชนสิ่งกีดขวาง (บนผิวจราจร)',
        'พลิกคว่ำ/ตกถนนในทางตรง',
        'พลิกคว่ำ/ตกถนนในทางโค้ง',
        '',
        'อื่นๆ',
        'ไม่ระบุ'
      ];
      if (this.options.hasOwnProperty('crash_pattern')) {
        let index = 0;
        let { accidentCount } = this;
        for (const key in this.options.crash_pattern) {
          if (this.options.crash_pattern[key] == 0) continue;
          chartcrash.series[0].data.push({
            name: key,
            x: index++,
            y: this.options.crash_pattern[key]
          });
          accidentCount -= this.options.crash_pattern[key];
        }
        if (accidentCount > 0) {
          chartcrash.series[0].data.push({
            name: 'ไม่ระบุ',
            x: index,
            y: accidentCount
          });
        }
      }
      return chartcrash;
    },
    getOptionType(key) {
      const data = this.spreadDataSource.filter(x => x.name === key);

      if (Object.keys(data).length > 0) {
        return data[0].type;
      }
      return 'checkbox';
    },
    getOptionTitle(key) {
      // console.log(this.spreadDataSource);
      const data = this.spreadDataSource.filter(x => x.name === key);
      if (Object.keys(data).length > 0) {
        return data[0].title;
      }
      return '-';
    },
    getChoicesName(key, val) {
      const data = this.spreadDataSource.filter(x => x.name === key);
      if (Object.keys(data).length > 0) {
        const result = data[0].data.filter(x => x.id.toString() === val.toString());
        if (result.length > 0) {
          return result[0].name;
        }
      }
      return '-';
    },
    getCasualtyCount() {
      let casualtyCount = 0;
      if (this.options.hasOwnProperty('wound_amount')) {
        for (const i in this.options.wound_amount) {
          casualtyCount += this.options.wound_amount[i];
        }
      }
      return casualtyCount;
    },
    getChartOptions(key, item) {
      const thisOptions = cloneDeep(this.chartOptions);
      const title = this.getOptionTitle(key);
      thisOptions.title.text = title;
      thisOptions.series[0].name = title;

      // console.log(key);
      // console.log(item);

      // return thisOptions;

      // if (this.getOptionType(key) === 'range') {
      //   const start = item[0] ? parseInt(item[0], 10) : 0;
      //   const end = item[1] ? parseInt(item[1], 10) : 120;
      //   const scale = Math.ceil((end - start) / 5);
      //   /* eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }] */
      //   for (let i = 1; i <= 5; i++) {
      //     const textStart = start + (i - 1) * scale;
      //     const textEnd = i !== 5 ? start + i * scale : end;

      //     thisOptions.series[0].data.push({
      //       name: `${textStart} - ${textEnd}`,
      //       y: this.randomAmount()
      //     });
      //   }
      // } else {
      Object.keys(item).forEach(val => {
        const name = this.getOptionType(key) === 'range' ? val : this.getChoicesName(key, val);
        const data = {
          name,
          y: item[val] // this.randomAmount()
        };
        thisOptions.series[0].data.push(data);
      });
      // }
      console.warn(thisOptions);
      return thisOptions;
    },
    randomAmount() {
      return Math.floor(Math.random() * 101);
    }
  },
  computed: {
    valueKeys() {
      return Object.keys(this.value);
    },
    valueKeysLength() {
      return this.valueKeys.length;
    },
    spreadDataSource() {
      const arr = [];
      this.dataSource.forEach(x => {
        arr.push(...x.options);
      });

      return arr;
    }
  }
};
</script>
<style lang="scss" scoped></style>
